(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["breadcrumbs"] && !Shopify.designMode) return;
  try {
    
  function matchBreadcrumbsToFirstSection() {
    document.querySelectorAll('[data-breadcrumbs-match-first-section="true"]').forEach((breadcrumbs) => {
      const firstBackground = document.querySelector('main .shopify-section .section-background');

      if (!firstBackground) return;

      const sourceStyles = getComputedStyle(firstBackground);
      const properties = [
        '--color-background',
        '--color-background-rgb',
        '--color-foreground',
        '--color-foreground-rgb',
        '--color-border',
        '--color-border-rgb',
      ];

      properties.forEach((property) => {
        const value = sourceStyles.getPropertyValue(property);
        if (value) breadcrumbs.style.setProperty(property, value);
      });

      breadcrumbs.style.backgroundColor = sourceStyles.backgroundColor;
      breadcrumbs.style.color = sourceStyles.color;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', matchBreadcrumbsToFirstSection);
  } else {
    matchBreadcrumbsToFirstSection();
  }

  document.addEventListener('shopify:section:load', matchBreadcrumbsToFirstSection);
  document.addEventListener('shopify:section:reorder', matchBreadcrumbsToFirstSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-occasion-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hb-occasion')) customElements.define('hb-occasion', class extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    const slides = [...this.querySelectorAll('[data-slide]')];
    const thumbs = [...this.querySelectorAll('[data-thumb]')];
    const stage = this.querySelector('.ho-stage');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let active = 0;
    let suppressClickUntil = 0;
    let scrollFrame = 0;
    const update = (index) => {
      active = Math.max(0, Math.min(index, slides.length - 1));
      slides.forEach((slide, i) => {
        slide.inert = i !== active;
        slide.setAttribute('aria-hidden', String(i !== active));
        if (i !== active) slide.querySelectorAll('video').forEach(video => video.pause());
      });
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === active)));
      const count = this.querySelector('[data-count]');
      if (count) count.textContent = `${active + 1} / ${slides.length}`;
      const previous = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (previous) previous.disabled = active === 0;
      if (next) next.disabled = active === slides.length - 1;
      const rail = this.querySelector('.ho-thumbs');
      if (rail && thumbs[active]) rail.scrollLeft = thumbs[active].offsetLeft - rail.offsetLeft - rail.clientWidth / 2 + 32;
    };
    const show = (index) => {
      if (!slides.length) return;
      const target = Math.max(0, Math.min(index, slides.length - 1));
      stage.scrollTo({ left: slides[target].offsetLeft, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
    };
    update(0);
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
    this.querySelector('[data-prev]')?.addEventListener('click', () => show(active - 1));
    this.querySelector('[data-next]')?.addEventListener('click', () => show(active + 1));
    this.querySelector('.ho-gallery').addEventListener('keydown', event => {
      if (event.key === 'ArrowRight') { event.preventDefault(); show(active + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(active - 1); }
    });
    // Native scroll snapping follows the finger and settles smoothly after release.
    stage.addEventListener('scroll', () => {
      suppressClickUntil = Date.now() + 300;
      if (scrollFrame) return;
      scrollFrame = requestAnimationFrame(() => {
        scrollFrame = 0;
        const index = Math.round(stage.scrollLeft / stage.clientWidth);
        if (index !== active) update(index);
      });
    }, { passive: true });
    stage.addEventListener('dragstart', event => {
      if (event.target.closest('[data-zoom]')) event.preventDefault();
    });
    stage.addEventListener('click', event => {
      if (Date.now() < suppressClickUntil) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    const dialog = this.querySelector('dialog');
    const fullStage = dialog.querySelector('[data-full-stage]');
    const fullSlides = [...dialog.querySelectorAll('[data-full-slide]')];
    const zoomLinks = [...this.querySelectorAll('[data-zoom]')];
    const fullPrevious = dialog.querySelector('[data-full-prev]');
    const fullNext = dialog.querySelector('[data-full-next]');
    let fullActive = 0;
    let fullScrollFrame = 0;
    const updateFull = index => {
      fullActive = Math.max(0, Math.min(index, fullSlides.length - 1));
      dialog.querySelector('[data-full-count]').textContent = `${fullActive + 1} / ${fullSlides.length}`;
      fullPrevious.disabled = fullActive === 0;
      fullNext.disabled = fullActive === fullSlides.length - 1;
      fullSlides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== fullActive)));
    };
    const showFull = (index, instant = false) => {
      if (!fullSlides.length) return;
      const target = Math.max(0, Math.min(index, fullSlides.length - 1));
      fullStage.scrollTo({left: fullSlides[target].offsetLeft, behavior: instant || reducedMotion.matches ? 'instant' : 'smooth'});
    };
    zoomLinks.forEach((link, index) => link.addEventListener('click', event => {
      event.preventDefault();
      dialog.showModal();
      updateFull(index);
      showFull(index, true);
    }));
    fullPrevious.addEventListener('click', () => showFull(fullActive - 1));
    fullNext.addEventListener('click', () => showFull(fullActive + 1));
    fullStage.addEventListener('scroll', () => {
      if (fullScrollFrame) return;
      fullScrollFrame = requestAnimationFrame(() => {
        fullScrollFrame = 0;
        const index = Math.round(fullStage.scrollLeft / fullStage.clientWidth);
        if (index !== fullActive) updateFull(index);
      });
    }, {passive: true});
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        showFull(fullActive + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    let wheelTotal = 0;
    let wheelUntil = 0;
    fullStage.addEventListener('wheel', event => {
      // Horizontal trackpad gestures stay native; a vertical mouse wheel changes photos.
      if (event.ctrlKey || Math.abs(event.deltaX) >= Math.abs(event.deltaY)) return;
      event.preventDefault();
      if (Date.now() < wheelUntil) return;
      wheelTotal += event.deltaY;
      if (Math.abs(wheelTotal) < 40) return;
      showFull(fullActive + Math.sign(wheelTotal));
      wheelTotal = 0;
      wheelUntil = Date.now() + 400;
    }, {passive: false});
    dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {
      const original = zoomLinks[fullActive]?.closest('[data-slide]');
      if (original) show(Number(original.dataset.slide));
    });
    const variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    const labels = JSON.parse(this.querySelector('[data-labels]').textContent);
    this.querySelector('select[name="id"]')?.addEventListener('change', event => {
      const variant = variants.find(item => String(item.id) === event.target.value);
      if (!variant) return;
      this.querySelector('[data-price]').textContent = variant.price;
      const compare = this.querySelector('[data-compare]');
      compare.textContent = variant.compare;
      compare.hidden = !variant.onSale;
      this.querySelectorAll('[data-sku]').forEach(el => el.textContent = variant.sku || '');
      const availability = this.querySelector('[data-availability]');
      availability.textContent = variant.available ? labels.available : labels.unavailable;
      availability.dataset.available = String(variant.available);
      const buy = this.querySelector('[data-buy]');
      buy.disabled = !variant.available;
      buy.firstChild.textContent = variant.available ? labels.buy : labels.unavailable;
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
      const mediaIndex = slides.findIndex(slide => slide.dataset.mediaId === String(variant.media));
      if (mediaIndex >= 0) show(mediaIndex);
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
